export const environment = {
  production: false,
  apiBaseUrl: '/api',
  /**
   * Client Payments & Subscription + FE subscription security.
   *
   * false — tenant admins/users/analysts use features free; hide client Billing.
   *         (Match backend SF_REQUIRE_SUBSCRIPTION=0 while Multispares test.)
   * true  — show Payments for tenant admins; unpaid users land on Billing;
   *         402 shows backend detail + Open Billing.
   *
   * Irish Taylor Billing overview is always available (not controlled here).
   */
  showBilling: false,

  /**
   * Master Subscription & Services Terms page (`/legal/terms`).
   *
   * DRAFT — Jeremy refining / lawyer engaged. true = page + links on for preview.
   * Set false before production until signed off. Guards use === true.
   */
  showTerms: true,

  /**
   * Immutable Terms identity recorded at acceptance (clause 1.5).
   * Bump here when Jeremy publishes a new version — do not hardcode in the document.
   */
  terms: {
    version: '1.1',
    /** Human-readable, as written in the Terms and acceptance record. */
    effectiveDate: '16 September 2026',
    /** Machine-readable for comparisons and acceptance payloads. */
    effectiveIso: '2026-09-16'
  },

  /** Contracting entity and public contact — footer, Terms, billing. */
  provider: {
    legalName: 'Irish Taylor & Co Pty Ltd',
    shortName: 'Irish Taylor',
    abn: '67 650 161 578',
    address: 'Level 1, 63-73 Ann Street, Surry Hills NSW 2010, Australia',
    contactEmail: 'onedesk@irishtaylor.com'
  }
};
